module.exports = __webpack_public_path__ + "img/Speaker=Syed Shahzad Raza.ba25d552.png";